import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { ProductVariantService } from '../../product-variant.service';
import { RxComponent } from 'app/core/components/common/rx.component';

@Component({
  selector: 'itpx-product-variant-edit-base',
  templateUrl: './product-variant-edit-base.component.html',
  styleUrls: ['./product-variant-edit-base.component.css']
})
export class ProductVariantEditBaseComponent extends RxComponent implements OnInit {

  @Input() form: FormGroup;
  @Input() isAddProductVariant: boolean;

  private productDict: any;
  // private productDict: Observable<{key: string, value: string}[]> = this.service.getProducts().map(_ => _.data);
  private languageDict: Observable<{key: string, value: string}[]> = this.service.getLanguages().map(_ => _.data);
  private deliveryFormatDict: Observable<{key: string, value: string}[]> = this.service.getDeliveryFormats().map(_ => _.data);
  private certificateTypeDict: Observable<{key: string, value: string}[]> = this.service.getCertificateTypes().map(_ => _.data);
  private examFulfillmentTypeDict: Observable<{key: string, value: string}[]> = this.service.getExamFulfillmentTypes().map(_ => _.data);
  private accountDeterminationGroupDict: Observable<{key: string, value: string}[]> = this.service.getAccountDeterminationGroups().map(_ => _.data);
  private fulfillmentTurnAroundTimeDict = [
      { key: 24, value: '24' },
      { key: 48, value: '48' },
      { key: 72, value: '72' }
  ];

  constructor(private service: ProductVariantService) {
      super();
  }

  ngOnInit() {
      this.service.getProducts()
          .bindToLifecycle(this)
          .subscribe(body  => this.productDict = body.data)
  }

}



// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/product-variants/common/base/product-variant-edit-base.component.ts